/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react';

export const NavMenuButton = ({ className, open }) => {
    return (
        <svg
            className={`nav-menu-button ${className}`}
            fill="none"
            height="40"
            viewBox="0 0 40 40"
            width="40"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                className="rect"
                fill="white"
                height="39"
                rx="7.5"
                width="39"
                x="0.5"
                y="0.5"
            />
            <rect
                className="rect"
                height="39"
                rx="7.5"
                stroke="#182042"
                width="39"
                x="0.5"
                y="0.5"
            />
            {open ? (
                <path
                    className="path"
                    d="M12 12L28 28M28 12L12 28"
                    stroke="#121926"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                />
            ) : (
                <path
                    className="path"
                    d="M11 20H29M11 14H29M11 26H29"
                    stroke="#121926"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                />
            )}
        </svg>
    );
};
